import React from 'react';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import { StockType } from 'models/stock.model';
import { formatCurrency, formatNumberWithCommas } from 'utils/functions';

type Props = {
  data: StockType[];
  loading: boolean;

  actionRenderer?: (stock: StockType) => React.ReactNode;
};

const BatchStockTable = ({
  data,
  loading,

  actionRenderer
}: Props) => {
  const TABLE_HEADERS = [
    'Item name',
    'Batch',
    'Qty available (g)',
    'Price (per piece)',
    'Expiry date (mmyy)',
    'Actions'
  ];

  return (
    <div>
      <Table headers={TABLE_HEADERS} loading={loading}>
        {data?.map((stock) => (
          <TableRow className='text-gray-12' key={stock.id}>
            <TableData className='text-gray-10'>{stock?.ingredient?.name}</TableData>
            <TableData className='text-gray-10 font-bold'>{stock?.batch_no ?? 0} </TableData>
            <TableData className='px-5 text-gray-5'>
              {formatNumberWithCommas(stock?.quantity ?? 0)}
            </TableData>
            <TableData>
              {formatCurrency(stock?.ingredient?.min_vendor_price, { style: 'decimal' })}
            </TableData>
            <TableData className='px-5 text-gray-5'>
              {stock?.expiration_date ? moment(stock?.expiration_date).format('MM/YY') : '-'}
            </TableData>
            <td className='flex-col h-full items-center gap-3'>
              {actionRenderer ? actionRenderer(stock) : ''}
            </td>
          </TableRow>
        ))}
      </Table>
    </div>
  );
};

export default BatchStockTable;
